import {useReposAppPayload} from '@github-ui/code-view-shared/contexts/FilesPageInfoContext'
import {newCodespaceForRepoPath} from '@github-ui/paths'
import {useNavigate, useParams} from '@github-ui/react-router'
import {GlobalCommands} from '@github-ui/ui-commands'

/**
 * Provides UI commands to open in external editors (github.dev and codespaces).
 *
 * Note: This conflicts with the behavior provided by the Rails `open_in_github_dev` partial on non-UI service-served
 * routes. When both are present, this will take precedence.
 */
export function OpenExternalEditorCommands() {
  const {owner, repo, branch} = useParams()
  const navigate = useNavigate()
  const {githubDevUrl} = useReposAppPayload()

  const openInGitHubDev = githubDevUrl
    ? (newWindow?: boolean) => {
        //need the pathname because the githubDevUrl is just the root
        const githubDevUrlWithPath = githubDevUrl
          ? new URL(window.location.pathname, githubDevUrl).toString()
          : undefined
        if (!githubDevUrlWithPath) return

        if (newWindow) {
          window.open(githubDevUrl, '_blank', 'noopener,noreferrer')
        } else {
          navigate(githubDevUrlWithPath)
        }
      }
    : undefined

  const openCodespace =
    owner && repo
      ? () => {
          window.open(newCodespaceForRepoPath({owner, repo, branch, resume: true}), '_blank')
        }
      : undefined

  return (
    <GlobalCommands
      commands={{
        'code-view:open-github-dev': openInGitHubDev && (() => openInGitHubDev()),
        'code-view:open-github-dev-new-window': openInGitHubDev && (() => openInGitHubDev(true)),
        'code-view:open-codespace': openCodespace,
      }}
    />
  )
}
